import React from "react";
import { OPTIONS, STATUS_OPTIONS } from "./config";
import FilterBar from "components/Common/FilterBar";

const Filter = (props) => {
  return (
    <FilterBar
      options={OPTIONS}
      statusOptions={STATUS_OPTIONS}
      {...props}
    />
  );
};

export default Filter;
